module.exports = __webpack_public_path__ + "static/media/ana_laura.cd5fcd92.jpg";